export const logEvent = (action, params = {}) => {
  if (window.gtag) {
    window.gtag("event", action, params);
  }
};
